import { MouseEventHandler, useEffect, useState } from 'react';

import { toggleAccessibility } from '../../db/app/actions';
import { selectAccessibilityPrefs } from '../../db/app/selectors';
import { useAppSelector } from '../../store/hooks';
import { useRequestDispatch } from '../../utils/request-actions';

const useAccessibilityFeaturesVM = () => {
  const requestDispatch = useRequestDispatch();

  const { turnOff } = useAppSelector((state) => selectAccessibilityPrefs(state));

  const [isTogglingAccessibility, setIsTogglingAccessibility] = useState(false);
  const [isAccessibilityOn, setIsAccessibilityOn] = useState(!turnOff);

  const handleToggleAccessibility: MouseEventHandler<HTMLInputElement> = async (event) => {
    try {
      setIsTogglingAccessibility(true);
      await requestDispatch(toggleAccessibility, isAccessibilityOn);
      // without using setState callback to keep it in sync with API layer.
      // callback won't be needed here because this operation is async.
      setIsAccessibilityOn(!isAccessibilityOn);
    } finally {
      setIsTogglingAccessibility(false);
    }
  };

  useEffect(
    function setInitialValues() {
      setIsAccessibilityOn(!turnOff);
    },
    [turnOff]
  );

  return { isTogglingAccessibility, isAccessibilityOn, handleToggleAccessibility };
};

export default useAccessibilityFeaturesVM;
